import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { GridApi } from "ag-grid-community";
import { MessageBoxComponent } from "src/app/common/message-box/message-box.component";
import { CommonService } from 'src/app/services/common.service';
import { GrantsSummaryService } from "src/app/services/grants/grants-summary.service";
import { GrantsAudiencesViewModalComponent } from './grants-audiences-view-modal/grants-audiences-view-modal.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HeadService } from "src/app/services/common/headservice";
import { GrantsDatashareService } from "src/app/services/grants/grants-datashare.service";
import { UserService } from "src/app/services/user.service";
import { Observable, tap } from "rxjs";
import { MasterDropDown } from "src/app/services/common/common-summary.service";
import { DeleteBoxComponent } from "src/app/common/delete-box/delete-box.component";
import { AudienceModel } from "src/app/models/common";

@Component({
  selector: 'app-grants-audiences',
  templateUrl: './grants-audiences.component.html',
  styleUrls: ['./grants-audiences.component.scss']
})
export class GrantsAudiencesComponent implements OnInit {

  columnDefs: any;
  operations: any;
  gridApi: GridApi;
  selectedRow: any;
  rowData: any;
  appid: string;
  permission: string;
  searchForm: UntypedFormGroup;
  collapesedOrNot: Boolean = false;
  audienceGroups$: Observable<MasterDropDown[]>;
  specialities$: Observable<MasterDropDown[]>;
  categoryOfCredits$: Observable<MasterDropDown[]>;
  staticformFields: any;
  userType: string;
  tempoperation: any[];

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private modalService: NgbModal,
    private userService: UserService,
    private commonService: CommonService,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService

  ) {
   
  }

  ngOnInit() {
    this.NavigateToGenInfo();
    this.buildAudienceForm();
    this.fetchDropDowns();
    this.permission = this.commonService.getPagePermission("GC04").toLowerCase();
    this.userType = this.userService.getUserType();
    const grantapp = this.commonService.getGrantsApp();
    this.appid = grantapp.ID;
    this.getStaticFiledsData('SCR-025');


    this.FetchAllAudience();
  }

  private buildAudienceForm() {
    this.searchForm = new UntypedFormGroup({
      AUDIENCE_GROUP_ID: new UntypedFormControl(""),
      SPECIALITY_ID: new UntypedFormControl(""),
      CREDIT_CATEGORY_ID: new UntypedFormControl("")
    });
  }

  private fetchDropDowns() {
    this.getAudinecesGroupList();
    this.getCategoryOfCreditOptions();
    this.getSpecialityOptionsList();
  }

  private getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode,this.appid)
      .subscribe({
        next: summary => {
          this.staticformFields = summary["Data"];

          this.columnDefs = [
            {
              "headerName": this.staticformFields?.AUDIENCE_GROUP_ID?.LABEL_NAME ?? "Audience Group",
              "field": "AUDIENCE_GROUP_IDStr",
              "sortable": true,
            },
            {
              "headerName": this.staticformFields?.SPECIALITY_ID?.LABEL_NAME ?? "Speciality",
              "field": "SPECIALITY_IDStr",
              "sortable": true,
            },
            {
              "headerName": this.staticformFields?.CREDIT_CATEGORY_ID?.LABEL_NAME ?? "Category of Credit",
              "field": "CREDIT_CATEGORY_IDStr",
              "sortable": true,
            },
            {
              "headerName": this.staticformFields?.CREDIT_HOURS?.LABEL_NAME ?? "CE/CME Credit Hours for Category",
              "field": "CREDIT_HOURSStr",
              "sortable": true,
            },
            // {
            //   "headerName": this.staticformFields?.NO_OF_INVITATIONS?.LABEL_NAME ?? "# of Invitations Expected to Distributed",
            //   "field": "NO_OF_INVITATIONS",
            //   "sortable": true,
            // },
            // {
            //   "headerName": this.staticformFields?.NO_OF_LEARNERS?.LABEL_NAME ?? "# of Expected Learners",
            //   "field": "NO_OF_LEARNERS",
            //   "sortable": true,
            // },
            // {
            //   "headerName": this.staticformFields?.NO_OF_CREDIT_RECEIVE_LEARNERS?.LABEL_NAME ?? "# of Learners Expected to Receive Credit",
            //   "field": "NO_OF_CREDIT_RECEIVE_LEARNERS",
            //   "sortable": true,
            // }
          ];
        }
      });
  }

  FetchAllAudience() {
    this.ClearSearch();
    this.AdvanceSearch();
  }

  ClearSearch() {
    this.searchForm.reset();
  }

  AdvanceSearch() {
    let formData = this.searchForm.value;
    let model = new AudienceModel();
    model.Text = "0";
    model.Type = "A";
    model.AppId = this.appid;
    model.AudienceGroupID = formData.AUDIENCE_GROUP_ID ?? "0";
    model.SpecialtyID = formData.SPECIALITY_ID ?? "0";
    model.CreditCategoryID = formData.CREDIT_CATEGORY_ID ?? "0";

    this.summaryService.getAudienceSummaryAdvSearch(model)
      .subscribe({
        next: summary => {
          this.rowData = this.setRowOperations(summary);
        }
      });
  }

  setRowOperations(rowData:any[])
  {
    this.tempoperation = [ ];
        this.tempoperation.push(
          {
            "name": "View",
            "id": "view"
          });
      
    if(this.permission!="view" ) 
    {
      this.tempoperation.push(
        {
          "name": "Edit",
          "id": "edit"
        });
      this.tempoperation.push(
          {
            "name": "Delete",
            "id": "delete"
          });
    }
    
    rowData.forEach(element=>{
      this.operations = this.tempoperation.map(operation => {
        return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      });
     
    });
    return rowData;
  }

  setDef(parmoperations: any) {
    this.operations = parmoperations.map(operation => {
      return { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows()
      ? this.gridApi.getSelectedRows()[0]
      : null;
  }

  onRowDoubleClicked(event) { }

  private getAudinecesGroupList() {
    this.audienceGroups$ = this.summaryService.getLookupListForSearch("LU-023",this.appid).pipe(
      tap(l => {
        l.unshift({ label: "All", value: null, checked: true });
      })
    );
  }

  private getCategoryOfCreditOptions() {
    this.categoryOfCredits$ = this.summaryService.getLookupListForSearch("LU-024",this.appid).pipe(
      tap(l => {
        l.unshift({ label: "All", value: null, checked: true });
      })
    );
  }

  private getSpecialityOptionsList() {
    this.specialities$ = this.summaryService.getLookupListForSearch("LU-028",this.appid).pipe(
      tap(l => {
        l.unshift({ label: "All", value: null, checked: true });
      })
    );
  }

  view(RecordData: any) {
    const modalRef = (this['self'] as GrantsAudiencesComponent).modalService.open(GrantsAudiencesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      animation: true,
      windowClass: "modal-vlg right modal-right"
    });

    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: RecordData['ID'], appid: this.appid }
    };

    modalRef.result.then(result => { });
  

  modalRef.result.then(result => {
    (this['self'] as GrantsAudiencesComponent).FetchAllAudience();
  });
}

  add() {
    const modalRef = this.modalService
      .open(GrantsAudiencesViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: "modal-llg right modal-right",
        animation: true
      });

    modalRef.componentInstance.Content = {
      heading: "Add",
      content: { id: "0", appid: this.appid }
    };

    modalRef.result.then(result => {
      this.FetchAllAudience();
    });
  }

  edit(RecordData: any) {
    const modalRef = this['self'].modalService.open(GrantsAudiencesViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-llg right modal-right',
        animation: true
      });

    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RecordData['ID'], appid: this.appid }
    }

    modalRef.result.then(result => {
      this['self'].FetchAllAudience();
    });
  }

  delete(RecordData: any) {
    const Modalref = this['self'].modalService.open(DeleteBoxComponent, { backdrop: false});

    Modalref.componentInstance.Content = {
      heading: '',
      custommessage: "Are you sure you want to delete the Audience?",
      ProceedButtonName: "Delete",
      TerminateButtonName: "Cancel"
    }

    Modalref.result.then(result => {
      if (result == "okclick") {
        let id = RecordData['ID'];
        (this['self'] as GrantsAudiencesComponent).summaryService.deleteAudience(id)
        .subscribe(summary => {  
          if(summary.Status == 0){
            //  const modelRef = (this['self'] as GrantsAudiencesComponent).modalService.open(MessageBoxComponent);
              this['self'].commonService.SuccessBanner('Audience deleted successfully');
              (this['self'] as GrantsAudiencesComponent).FetchAllAudience();
            }
          })
        }
          });
    }



  NavigateToGenInfo() {
    this.appid = this.commonService.appId;
    let MenuModule = this.commonService.getModuleMenu();
    if (this.appid == null || this.appid == undefined || this.appid == "") {
      const modalRefAu = this.modalService.open(MessageBoxComponent, {});
      modalRefAu.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Audiences', operation: { hasConfirm: false } } };
      modalRefAu.result.then((result) => {
        this.router.navigate(['/home/grants/my-applications/application-ext/:' + 0 + '/geninfocme'],
          { skipLocationChange: true, queryParams: { id: 0, app_ext: true, module: "grants", submodule: MenuModule.module, screen_type: "my-applications" } })
      });
      return false;
    }
  }
}
